import { apolloProvider } from '@/apollo-provider.js'
import { QUERY_GET_PRODUCTS_ANALYTICS, QUERY_GET_BOOSTING_PRODUCTS, MUTATION_SALES_PRODUCTS_ANALYSIS_REPORT } from '../graphql'
import { microservicesUrls } from '@/plugins/microservices/microservices'
export default {
  async getProductAnalytics({ state, commit, dispatch }, variables) {
    const { productAnalytics } = await apolloProvider.defaultClient
      .query({
        query: QUERY_GET_PRODUCTS_ANALYTICS,
        variables,
        fetchPolicy: 'no-cache',
      })
      .then(
        ({
          data: {
            productAnalytics: { productAnalytics, records },
          },
        }) => {
          return { productAnalytics, records }
        }
      )
    commit('SET_OPPORTUNITIES_KEY', { key: 'productAnalytics', payload: productAnalytics })
  },
  async getBoostProducts({ state, commit, dispatch }, variables) {
    const { salesBoostingProducts } = await apolloProvider.defaultClient
      .query({
        query: QUERY_GET_BOOSTING_PRODUCTS,
        variables,
        fetchPolicy: 'no-cache',
      })
      .then(
        ({
          data: {
            salesBoostingProducts: { salesBoostingProducts },
          },
        }) => {
          return { salesBoostingProducts }
        }
      )
    commit('SET_OPPORTUNITIES_KEY', { key: 'boostProducts', payload: salesBoostingProducts })
  },
  exportSalesProductsAnalysis({ state }, variables) {
    return new Promise((resolve, reject) => {
      const { currentDate, referenceDate, units, products } = state.opportunities.filters
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_SALES_PRODUCTS_ANALYSIS_REPORT,
          variables: {
            ...variables,
            products: products.map((product) => product.sku),
            currentInitialDate: currentDate[0],
            currentFinalDate: currentDate[1],
            referenceInitialDate: referenceDate[0],
            referenceFinalDate: referenceDate[1],
            units,
          },
          fetchPolicy: 'no-cache',
          context: {
            uri: microservicesUrls['asyncJobs'],
          },
        })
        .then(
          (data) => {
            resolve(data)
          },
          (error) => {
            reject(error)
          }
        )
    })
  },
}
